<script setup lang="ts">
import type { KanbanLogActor } from '@entities/kanban-comment'

import { KANBAN_LOG_EMPTY_VALUE } from '@entities/kanban-comment'
import { AppText, AppTextLink } from '@shared/ui/typography'

import { useKanbanLogCreator } from '../../model/log/use-kanban-log-creator.hook'
import KanbanLogItemInfo from './KanbanLogItemInfo.vue'

defineOptions({
  name: 'KanbanLogCreator',
})

const props = defineProps<{
  actor: KanbanLogActor | null
  creator: KanbanLogActor | null | undefined
}>()

const {
  refCreator,
} = useKanbanLogCreator({
  creator: props.creator,
})
</script>

<template>
  <div class="kanban-log-field">
    <KanbanLogItemInfo
      :actor="actor"
      label="set creator"
    />
    <div class="kanban-log-field__row">
      <AppTextLink
        v-if="refCreator?.url"
        name="body2-medium"
        color="blue-700"
        :href="refCreator.url"
        target="_blank"
      >
        {{ refCreator.name }}
      </AppTextLink>
      <AppText
        v-else-if="refCreator"
        name="body2"
        color="slate-900"
      >
        {{ refCreator.name }}
      </AppText>
      <AppText
        v-else
        name="body2"
        color="slate-400"
        class="unassigned"
      >
        {{ KANBAN_LOG_EMPTY_VALUE }}
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@shared/ui/kanban/styles/_kanban-log-field.scss" />